module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-TW":{"media_summary_title":"照片&視頻","show_all":"全部圖片/視頻"}}')
  delete Component.options._Ctor
}
